export interface UmbracoNodeModel {
	UmbracoNodeId: number;
	UmbracoNodeName: string;
}

export class NewsletterSignUpFormRequestModel {
	RecaptchaToken: string = '';
	FirstName: string = '';
	LastName: string = '';
	Email: string = '';
	PhoneNumber: string = '';
	UmbracoNodeId: number = 0;
	AgreeToPromotions: boolean = false;
	AgreeToShareDetails: boolean = false;
	AgreeToSTHPromotions: boolean = false;

	constructor(data: Partial<NewsletterSignUpFormRequestModel>) {
		Object.assign(this, data);
	}
}
